import {
  INQUIRY_STATUS_LABEL_MAP,
  INQUIRY_STATUS_LEVEL_MAP,
} from 'dashboard/lib/constants/inquiry';
import { InquiryStatus } from 'dashboard/models/inquiry';
import Sticker from 'design-system/components/Sticker';

interface InquiryStickerProps {
  id?: string;
  'data-test'?: string;
  status?: InquiryStatus;
}

const InquiryStatusSticker = ({ status = InquiryStatus.Created }: InquiryStickerProps) => (
  <Sticker variant={INQUIRY_STATUS_LEVEL_MAP[status]}>{INQUIRY_STATUS_LABEL_MAP[status]}</Sticker>
);

export default InquiryStatusSticker;
